import { Spacing } from '@doordash/design-language'
import styled from 'styled-components'

type WrapperType = {
  isCentered: boolean
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ isCentered }: WrapperType) =>
    isCentered ? 'center' : 'unset'};
  text-align: ${({ isCentered }: WrapperType) =>
    isCentered ? 'center' : 'unset'};
  padding-left: ${Spacing.Medium}px;
  padding-right: ${Spacing.Medium}px;
`

export const SkipContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

export const VehicleForm = styled.form`
  width: '100%';
`

export const Bottom = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${Spacing.Large}px;

  @media (max-height: 700px) {
    position: relative;
    padding: ${Spacing.XLarge}px 0;
  }
`
